import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
// routes
import { RouterLink } from 'src/routes/components';
import Image from 'src/components/image';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, logosize, ...other }, ref) => {
  const theme = useTheme();

  const PRIMARY_LIGHT = theme.palette.primary.light;

  const PRIMARY_MAIN = theme.palette.primary.main;

  const PRIMARY_DARK = theme.palette.primary.dark;

  // OR using local (public folder)
  // -------------------------------------------------------
  // const logo = (
  //   <Box
  //     component="img"
  //     src="/logo/logo_single.svg" => your path
  //     sx={{ width: 40, height: 40, cursor: 'pointer', ...sx }}
  //   />
  // );

  const logo = (
    <Box
      ref={ ref }
      component="div"
      sx={ {
        width: logosize ? 50 : 150,
        height: 50,
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        overflow: 'hidden',
        ...sx,
      } }
      { ...other }
    >
      <Image
        alt="grid"
        src={ logosize ? "/assets/images/ezelogs-favicon.png" : "/assets/images/ezelogs-logo2.png" }
        style={ {
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
        } }
      />
    </Box>

  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={ RouterLink } href="/" sx={ { display: 'contents' } }>
      { logo }
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
